<template>
  <Vcontainer>
    <VRow justify="center">
      <VCol cols="12" md="8">
        <VCard elevation="1" class="pa-3 pa-md-7 px-md-12 mb-5">
          <p>
            <strong>
              Правила оплаты и безопасность платежей, конфиденциальность информации
            </strong>
          </p>
          <p>
            Оплата банковскими картами осуществляется через АО «АЛЬФА-БАНК».
          </p>
          <p>
            К оплате принимаются карты VISA, MasterCard, МИР.
          </p>
          <p>
            <img src="../assets/img/payments/all.jpg">
          </p>
          <p>
            Услуга оплаты через Интернет осуществляется в соответствии с Правилами
            международных платёжных систем Visa, MasterCard и Платёжной системы МИР
            на принципах соблюдения конфиденциальности и безопасности совершения
            платежа, для чего используются самые современные методы проверки,
            шифрования и передачи данных по закрытым каналам связи. Ввод данных
            банковской карты осуществляется на защищенной платёжной странице АО
            «АЛЬФА-БАНК».
          </p>
          <p>
            На странице для ввода данных банковской карты потребуется ввести данные
            банковской карты: номер карты, имя владельца карты, срок действия карты,
            трёхзначный код безопасности (CVV2 для VISA, CVC2 для MasterCard, Код
            Дополнительной Идентификации для МИР). Все необходимые данные пропечатаны
            на самой карте. Трёхзначный код безопасности — это три цифры, находящиеся
            на обратной стороне карты.
          </p>
          <p class="indent">
            Далее вы будете перенаправлены на страницу Вашего банка для ввода кода
            безопасности, который придёт к Вам в СМС. Если код безопасности к Вам не
            пришёл, то следует обратиться в банк, выдавший Вам карту.
          </p>
          <p>
            <strong>Случаи отказа в совершении платежа:</strong>
            <ul>
              <li>
                банковская карта не предназначена для совершения платежей через Интернет,
                о чем можно узнать, обратившись в Ваш Банк;
              </li>
              <li>
                недостаточно средств для оплаты на банковской карте. Подробнее о наличии
                средств на банковской карте Вы можете узнать, обратившись в банк,
                выпустивший банковскую карту;
              </li>
              <li>
                данные банковской карты введены неверно;
              </li>
              <li>
                истёк срок действия банковской карты. Срок действия карты,
                как правило, указан на лицевой стороне карты (это месяц и год,
                до которого действительна карта). Подробнее о сроке действия
                карты Вы можете узнать, обратившись в банк, выпустивший банковскую карту;
              </li>
            </ul>
          </p>
          <p>
            По вопросам оплаты с помощью банковской карты и иным вопросам,
            связанным с работой сайта, Вы можете обращаться в техподдержку
            <a :href="`mailto:${SUPPORT_EMAIL}`">{{ SUPPORT_EMAIL }}</a>.
          </p>
          <p class="indent">
            Предоставляемая вами персональная информация (имя, адрес, телефон,
            e-mail, номер банковской карты) является конфиденциальной и не подлежит
            разглашению. Данные вашей кредитной карты передаются только в зашифрованном
            виде и не сохраняются на нашем Web-сервере.
          </p>
          <p>
            <strong>Правила возврата денежных средств</strong>
          </p>
          <p>
            После того, как Услуги считается оказанными, возврат денежных средств за
            оказание таких Услуг не производится.
          </p>
          <p>
            Услуги считаются оказанными Компанией с момента обеспечения возможности
            использования Заказчиком соответствующих функциональных возможностей
            Сервиса посредством открытия и резервирования доступа к ним Заказчика
            на соответствующий срок и/или в соответствующем объеме во внутренней
            учетной системе Компании. При этом, Услуги признаются оказанными в полном
            объеме независимо от того, использовал ли Заказчик в полном объеме
            предусмотренные пакетом опции.
          </p>
          <p>
            Таким образом, возврат денежных средств за Услуги возможен только в случае,
            если Заказчику не был открыт доступ к платным опциям Сервиса. Соответственно,
            возврат денежных средств возможен до момента первого использования одной из
            опций тарифа (отклик/звонок или SMS).
          </p>
          <p>
            При оплате картами возврат наличными денежными средствами не допускается.
            Порядок возврата регулируется правилами международных платежных систем.
          </p>
          <p>
            Для возврата денежных средств на банковскую карту необходимо заполнить
            «Заявление о возврате денежных средств», которое высылается по требованию
            компанией на электронный адрес, и оправить его вместе с приложением копии
            паспорта по адресу <a :href="`mailto:${SUPPORT_EMAIL}`">{{ SUPPORT_EMAIL }}</a>
          </p>
          <p>
            Возврат денежных средств будет осуществлен на банковскую карту в течение 21
            (двадцати одного) рабочего дня со дня получения «Заявление о возврате денежных
            средств» Компанией.
          </p>
          <p>
            Для возврата денежных средств по операциям проведенными с ошибками необходимо
            обратиться с письменным заявлением и приложением копии паспорта и чеков/квитанций,
            подтверждающих ошибочное списание. Данное заявление необходимо направить по адресу
            <a :href="`mailto:${SUPPORT_EMAIL}`">{{ SUPPORT_EMAIL }}</a>
          </p>
          <p class="indent">
            Сумма возврата будет равняться сумме покупки. Срок рассмотрения Заявления и возврата
            денежных средств начинает исчисляться с момента получения Компанией Заявления и
            рассчитывается в рабочих днях без учета праздников/выходных дней.
          </p>
          <p>
            <strong>Контактная информация</strong>
          </p>
          <table>
            <tr><td>Название компании</td><td>ООО "БОЗОН"</td></tr>
            <tr><td>ИНН / КПП</td><td>9701116384 / 770101001</td></tr>
            <tr><td>ОГРН</td><td>1187746716563</td></tr>
            <tr><td>Фактический адрес</td><td>105005, г. Москва, ул. Фридриха Энгельса, д. 46, стр. 2</td></tr>
            <tr><td>e-mail</td><td><a :href="`mailto:${SUPPORT_EMAIL}`">{{ SUPPORT_EMAIL }}</a></td></tr>
          </table>
        </VCard>
      </VCol>
    </VRow>
  </Vcontainer>
</template>

<script>
import { SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'PaymentRules',
  data() {
    return {
      SUPPORT_EMAIL,
    };
  },
};
</script>

<style scoped>
table {
    border-collapse: collapse;
    width: 100%;
}

th, td {
    border: 1px solid black;
    padding: 15px;
}

.indent {
  margin-bottom: 55px;
}

</style>
